import axios from "axios";

export const getIndustries = async ()=> {
    return await axios.get(process.env.REACT_APP_API_URL+'industries/')
}
